var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageViewer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21875 4.29395C9.91267 3.9548 10.7458 4.09447 11.292 4.64062L11.4111 4.75977C11.4926 4.84127 11.5659 4.93051 11.6299 5.02637C12.0228 5.61569 12.0228 6.38431 11.6299 6.97363L11.4531 7.23926C10.7668 8.26881 10.4005 9.47846 10.4004 10.7158V11.4033C10.4003 11.7027 10.3302 11.9979 10.1963 12.2656L10.1797 12.2988C10.1488 12.3606 10.0857 12.4002 10.0166 12.4004C9.94349 12.4004 9.87746 12.3562 9.84863 12.2891L9.25586 10.9062C8.78271 9.80254 7.21729 9.80254 6.74414 10.9062L6.15137 12.2891C6.12254 12.3562 6.05651 12.4004 5.9834 12.4004C5.91431 12.4002 5.85122 12.3606 5.82031 12.2988L5.80371 12.2656C5.66984 11.9979 5.59966 11.7027 5.59961 11.4033V10.7158C5.59954 9.47846 5.23324 8.26881 4.54688 7.23926L4.37012 6.97363C3.97724 6.38431 3.97724 5.61569 4.37012 5.02637C4.43406 4.93051 4.50741 4.84127 4.58887 4.75977L4.70801 4.64062C5.25416 4.09447 6.08733 3.9548 6.78125 4.29395L6.87402 4.33984C7.22462 4.51115 7.60978 4.59961 8 4.59961C8.39022 4.59961 8.77538 4.51115 9.12598 4.33984L9.21875 4.29395Z",
    stroke: "#002A69",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4V3.9C2.5 3.1268 3.1268 2.5 3.9 2.5H4",
    stroke: "#002A69",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12V12.1C2.5 12.8732 3.1268 13.5 3.9 13.5H4",
    stroke: "#002A69",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4V3.9C13.5 3.1268 12.8732 2.5 12.1 2.5H12",
    stroke: "#002A69",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12V12.1C13.5 12.8732 12.8732 13.5 12.1 13.5H12",
    stroke: "#002A69",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageViewer);
export default __webpack_public_path__ + "static/media/Image_viewer.293ef3fa09caf3484263373d269915a4.svg";
export { ForwardRef as ReactComponent };